// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-data-grid-pro';
// import { LicenseInfo } from '@mui/x-license';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import GlobalStyle from '../../GlobalStyle';
import theme from '../../theme';
import ToastNotifier from '../../components/ToastNotifier/ToastNotifier';
import AdminPage from '../AdminPage';
import { useTypedSelector } from '../../store';
import { useDispatch } from 'react-redux';
import {
  selectUser,
  selectUserEmail,
  selectUserPermissions,
  selectUserRole,
} from '../../store/userData/selectors';
// import LoadingScreen from '../../common/LoadingScreen';
import CurrencyPage from '../../components/CurrencyPage';
import { fetchCurrency } from '../../store/currency/actionWrappers';

// import useTranslation from '../../hooks/useTranslation';
import { selectDataActions } from '../../store/selectData/slice';
import { checkIfAllowed } from '../../utils/restrictionFile';
// import ProductionLinkModal from '../../components/ProductionLinkModal';
import ReactGA from 'react-ga4';
import { env } from '../../env';

import { IngkaLayout } from '../IngkaLayout/IngkaLayout';
import { ProjectListPage } from '../ProjectListPage/ProjectListPage';
import PopupModal from '../../components/PopupModal';
import { getOpenedPopupModal } from '../../store/app/selectors';
import LoadingScreen from '../../common/LoadingScreen';
import useTranslation from '../../hooks/useTranslation';
import ApprovalPage from '../ApprovalPage';
import {
  AD,
  roleRestricted,
  SA,
  GU,
  PC,
} from '../../components/RoleRestricted/utils';
import { userDetailsActions } from '../../store/users/slice';
import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ArchivePage from '../ArchivePage';
import GuestAccessNotification from '../../components/GuestAccessNotification/GuestAccessNotification';
import { sendUserActionWithId } from '../../utils/googleAnalytics';
import BulkEdit from '../BulkEdit';
import UserSatisfactionModal from '../UserSatisfactionModal';
import { checkIfDatePassed, hashEmail } from './utils';
import { submitFeedBack } from '../../store/userData/actionWrappers';
import BulkCreate from '../BulkCreate';
import { useAnalytics } from '../../hooks/useAnalytics';
import Analytics from '../Analytics';
import FinancialFrames from '../FinancialFrames';

ReactGA.initialize(env.REACT_APP_GOOGLE_ANALYTICS_KEY);
LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_PREMIUM_KEY);

const getClassnameByPathname = (pathname: string) => {
  const path = pathname.split('/')[1];

  return path ? path : 'projects';
};

const setUserId = async (email) => {
  const hash = await hashEmail(email);
  ReactGA.set({ user_id: hash });
  sendUserActionWithId('Login', hash);
};

// TODO-PPM revert changes
const App = () => {
  const [viewData, setViewData] = useState({ time: 0, location: '' });
  const dispatch = useDispatch();
  const { sendEvent } = useAnalytics('user');
  const t = useTranslation();
  const role = useTypedSelector(selectUserRole);
  const email = useTypedSelector(selectUserEmail);
  const permissions = useTypedSelector(selectUserPermissions);
  const popupModal = useTypedSelector(getOpenedPopupModal);
  const user = useTypedSelector(selectUser);
  const [satisfactionModal, setSatisfactionModal] = React.useState(false);
  // const [prodLinkModal, setProdLinkModal] = useState(
  //   window.location.hostname === FRONT_STAGING_HOSTNAME,
  // );
  const location = useLocation();

  useEffect(() => {
    if (email) {
      dispatch(fetchCurrency());
      dispatch(selectDataActions.fetchBusinessUnits());
      dispatch(userDetailsActions.fetchUsers());
      setUserId(email);
      sendEvent({ eventSubType: 'login' });
    }
  }, [email]);
  const submitFeedBackHandler = (data) => {
    dispatch(submitFeedBack({ ...data, userId: user.id }));
    if (data.submitted) {
      sendEvent({ eventSubType: 'feedBack', context: { rating: data.rating } });
    }
    setSatisfactionModal(false);
  };
  useEffect(() => {
    if (user?.id) {
      if (checkIfDatePassed(user.nextFeedbackDate)) {
        setTimeout(() => setSatisfactionModal(true), 60000);
      }
    }
  }, [user]);
  useEffect(() => {
    if (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      location.state?.from !== 'project' &&
      location.pathname.split('/')[0] !== 'project'
    ) {
      if (viewData.location) {
        sendEvent({
          eventSubType: 'pageView',
          context: {
            duration: Math.floor((Date.now() - viewData.time) / 1000),
            location: viewData.location,
          },
        });
      }
      setViewData({ time: Date.now(), location: location.pathname });
    }
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ToastNotifier />
      <Stack
        className={`stack-container ${getClassnameByPathname(location.pathname)}`}
      >
        <IngkaLayout>
          <PopupModal visible={popupModal} />
          <Switch>
            {role && roleRestricted([AD, SA, PC], role) ? (
              <>
                <Switch>
                  <Route
                    path="/admin-page"
                    render={() =>
                      !roleRestricted([AD, SA], role) ? (
                        <Redirect to={'/'} />
                      ) : (
                        <AdminPage />
                      )
                    }
                  />
                  <Route
                    path="/currency-page"
                    render={() =>
                      checkIfAllowed(permissions, 'currency') ? (
                        <CurrencyPage />
                      ) : (
                        <Redirect to={'/'} />
                      )
                    }
                  />
                  <Route
                    path="/approval"
                    render={() =>
                      !roleRestricted([SA], role) ? (
                        <Redirect to={'/'} />
                      ) : (
                        <ApprovalPage />
                      )
                    }
                  />
                  <Route
                    path="/analytics"
                    render={() =>
                      checkIfAllowed(permissions, 'analytics') ? (
                        <Analytics />
                      ) : (
                        <Redirect to={'/'} />
                      )
                    }
                  />
                  <Route path="/archive" render={() => <ArchivePage />} />
                  <Route
                    path="/financial-frames"
                    render={() =>
                      !roleRestricted([SA], role) ? (
                        <Redirect to={'/'} />
                      ) : (
                        <FinancialFrames />
                      )
                    }
                  />
                  <Route path="/bulk-edit" render={() => <BulkEdit />} />
                  <Route path="/bulk-create" render={() => <BulkCreate />} />
                  <Route
                    path="/project/:projectId"
                    render={() => <ProjectListPage />}
                  />
                  <Route path="/" render={() => <ProjectListPage />} />
                </Switch>
              </>
            ) : roleRestricted([GU], role) ? (
              <GuestAccessNotification countryAdminListUrl="http://localhost:3000/country-admin-list" />
            ) : (
              <LoadingScreen
                message={t('common.loadingMsg.checkingYourPermissions')}
              />
            )}
          </Switch>
        </IngkaLayout>
      </Stack>
      <UserSatisfactionModal
        visible={satisfactionModal}
        submitHandler={submitFeedBackHandler}
      />
      {/*<ProductionLinkModal*/}
      {/*  visible={prodLinkModal}*/}
      {/*  closeHandler={() => setProdLinkModal(false)}*/}
      {/*/>*/}
    </ThemeProvider>
  );
};

export default App;
